// a simple function to shorten the wallet address to diply in UI
export const shortenAddress = (address: string) => {
  if (!address) return ''
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};
